import { StorageProvider } from "src/providers";
import { icon, Icon } from "src/controls";

interface ModeSwitchItem {
	key: string,
	icon: icon,
}

interface ModeSwitchOptions {
	setModeHandler: (mode: string) => void,
	defaultItem: ModeSwitchItem,
	alternativeItem: ModeSwitchItem,
	localStorage?: boolean,
}

export class ModeSwitch {
	inputElement: JQuery<HTMLInputElement>;
	items: Map<string, icon>;
	currentButton: JQuery | null = null;
	storage: StorageProvider<boolean> | undefined;

	constructor(selector: string | HTMLElement, private options: ModeSwitchOptions) {
		if (typeof selector === 'string') {
			this.inputElement = $(selector);
		} else if (selector instanceof HTMLInputElement) {
			this.inputElement = $(selector);
		} else {
			throw new Error('Dropdown selector must be a string or HTMLInputElement');
		}

		if (this.options.localStorage) {
			this.storage = new StorageProvider<boolean>(this.inputElement.attr('id')!, { query: false });
		}

		this.items = new Map([
			[this.options.defaultItem.key, this.options.defaultItem.icon],
			[this.options.alternativeItem.key, this.options.alternativeItem.icon]
		]);
		const selected = this.loadValue();
		this.changeMode(selected ? this.options.alternativeItem.key : this.options.defaultItem.key);
	}

	changeMode(mode: string) {
		this.saveValue(mode != this.options.defaultItem.key);
		this.options.setModeHandler.call(this, mode);
		this.createButton(mode);
	}

	createButton(mode: string) {
		mode = this.not(mode);
		this.currentButton?.remove();
		this.currentButton = Icon.JQuery(this.items.get(mode)!, {
			ariaLabel: `Activate ${mode} mode`, onClick: _ => {
				this.changeMode(mode)
			}
		}).insertAfter(this.inputElement);
		// this.currentButton = $(`<button class="btn" aria-label="Activate ${mode} mode">${this.items.get(mode)}</button>`)
		// 	.insertAfter(this.inputElement)
		// 	.on('click', _ => {
		// 		this.changeMode(mode)
		// 	});
	}

	not(mode: string) {
		return mode == this.options.defaultItem.key ? this.options.alternativeItem.key : this.options.defaultItem.key
	};

	private saveValue(value: boolean) {
		if (this.storage) {
			this.storage.value = value;
		}
		this.inputElement.prop('checked', value);
	}

	private loadValue(): boolean {
		let value: any = this.storage?.value;
		if (typeof value !== "undefined") return value;
		return this.inputElement.prop('checked') as boolean;
	}
}